import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchGetAdminCheckout } from '../../../../actions/admin';
import InputWrapper from '../../../common/InputWrapper';
import Toogle from '../../../common/Toogle';
import Checkbox from '../../../common/Checkbox';
import { preventSubmittingByEnter } from '../../../../helpers';
import Select from '../../../common/Select';

const Checkout = (props) => {
  const { values, handleChangeInput, handleSubmit } = props;
  const dispatch = useDispatch();
  const { checkout } = useSelector((state) => state.admin);

  const handleUpdateCheckbox = (e) => {
    handleChangeInput(e.target.id, e.target.checked);
  };

  useEffect(() => {
    dispatch(fetchGetAdminCheckout());
  }, []);

  const REGION_DELIVERY_OPTIONS = [
    { value: 'RU', label: 'Россия' },
    { value: 'RU_SNG', label: 'Страны СНГ' },
    { value: 'ALL', label: 'Другие варианты' },
  ];

  const PAYMENT_PROVIDERS = [
    { value: 'PAYU', label: 'PAYU' },
    { value: 'YANDEX', label: 'YANDEX' },
    { value: 'QIWI', label: 'QIWI' },
    { value: 'ROBOKASSA', label: 'ROBOKASSA' },
    { value: 'PORTMONE', label: 'PORTMONE' },
  ];

  const renderCheckoutSettings = (item) => {
    return (
      <>
        <div className="row">
          <div className="col-6">
            <div className="form-group">
              <h5>Обязательные к заполнению поля формы заказа</h5>
              <Checkbox
                label="Телефон"
                id="uiRequiredPhone"
                checked={values.checkout?.uiRequiredFields[0]} //TODO: додумать
                onChange={handleUpdateCheckbox}
                inlineLayout
              />
              <Checkbox
                label="Email"
                id="uiRequiredEmail"
                checked={values.checkout?.uiRequiredFields[1]} //TODO: додумать
                onChange={handleUpdateCheckbox}
                inlineLayout
              />
            </div>
            <div className="form-group">
              <div className="row">
                <div className="col-6">
                  <InputWrapper
                    label="confidentialPolicyLink"
                    id="confidentialPolicyLink"
                    value={values.checkout?.confidentialPolicyLink}
                    onChange={(e) => handleChangeInput('confidentialPolicyLink', e.target.value)}
                  />
                </div>
                <div className="col-6">
                  <InputWrapper
                    label="Страна"
                    id="country"
                    value={values.checkout?.country}
                    onChange={(e) => handleChangeInput('country', e.target.value)}
                  />
                </div>
              </div>
              <div className="row" style={{ marginTop: '16px' }}>
                <div className="col-6">
                  <InputWrapper
                    label="Валюта"
                    id="currency"
                    value={values.checkout?.currency}
                    onChange={(e) => handleChangeInput('currency', e.target.value)}
                  />
                </div>
                <div className="col-6">
                  <InputWrapper
                    label="deliveryPremiumType"
                    id="deliveryPremiumType"
                    value={values.checkout?.deliveryPremiumType}
                    onChange={(e) => handleChangeInput('deliveryPremiumType', e.target.value)}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="col-6">
            <h5>Список галочек</h5>
            <div className="form-group">
              <Checkbox
                label="allowSNG"
                id="allowSNG"
                checked={values.checkout?.allowSNG}
                onChange={handleUpdateCheckbox}
              />
            </div>
            {/*            <div className="form-group">
              <Checkbox
                label={'commercialAccountDelete'}
                id="commercialAccountDelete"
                checked={values.checkout?.commercialAccountDelete}
                onChange={handleUpdateCheckbox}
              />
            </div>*/}
            <div className="form-group">
              <Checkbox
                label={'commercialAccountRequested'}
                id="commercialAccountRequested"
                checked={values.checkout?.commercialAccountRequested}
                onChange={handleUpdateCheckbox}
              />
            </div>
            <div className="form-group">
              <Checkbox
                label={'disableCodSumInTariff'}
                id="disableCodSumInTariff"
                checked={values.checkout?.disableCodSumInTariff}
                onChange={handleUpdateCheckbox}
              />
            </div>
            <div className="form-group">
              <Checkbox
                label={'disableInsuranceSumInTariff'}
                id="disableInsuranceSumInTariff"
                checked={values.checkout?.disableInsuranceSumInTariff}
                onChange={handleUpdateCheckbox}
              />
            </div>
            <div className="form-group">
              <Checkbox
                label={'disablePRRInTariff'}
                id="disablePRRInTariff"
                checked={values.checkout?.disablePRRInTariff}
                onChange={handleUpdateCheckbox}
              />
            </div>
          </div>
        </div>
        {/*TODO: Добавить настройки региона - deliveryRegionSettings */}
        <section>
          <h4 className="header-title" style={{ marginTop: '16px' }}>
            Настройки email-данных
          </h4>
          <div className="row">
            <div className="col-6">
              <div className="form-group">
                <InputWrapper
                  id="host"
                  label="Хост"
                  value={values.checkout?.emailData?.host || ''}
                  onChange={(e) => handleChangeInput('host', e.target.value)}
                />
              </div>
              <div className="form-group">
                <InputWrapper
                  id="password"
                  label="Пароль"
                  value={values.checkout?.emailData?.password || ''}
                  onChange={(e) => handleChangeInput('password', e.target.value)}
                />
              </div>
            </div>
            <div className="col-6">
              <div className="form-group">
                <InputWrapper
                  id="port"
                  label="Порт"
                  value={values.checkout?.emailData?.port || ''}
                  onChange={(e) => handleChangeInput('port', e.target.value)}
                />
              </div>
              <div className="form-group">
                <InputWrapper
                  id="username"
                  label="Имя пользователя"
                  value={values.checkout?.emailData?.username || ''}
                  onChange={(e) => handleChangeInput('username', e.target.value)}
                />
              </div>
            </div>
            <div className="col-6">
              <div className="form-group">
                <Toogle
                  id="isActivePersonalEmail"
                  label="Активность личного емейла"
                  checked={values.checkout?.emailData?.isActivePersonalEmail}
                  onChange={handleUpdateCheckbox}
                />
              </div>
            </div>
          </div>
        </section>
        <section>
          <h4 className="header-title" style={{ marginTop: '16px' }}>
            Настройки доставщика
          </h4>
          <div className="row">
            <div className="col-6">
              <div className="form-group">
                <Select
                  label="Регион бесплатной доставки"
                  options={REGION_DELIVERY_OPTIONS}
                  value={REGION_DELIVERY_OPTIONS.find(
                    (o) => o.value === values.checkout?.freeDeliveryRegion,
                  )}
                  onChange={({ value }) => handleChangeInput(`freeDeliveryRegion`, value)}
                />
              </div>
              <div className="form-group">
                <InputWrapper
                  id="insurancePercent"
                  label="Процент страховки"
                  value={values.checkout?.insurancePercent}
                  onChange={(e) => handleChangeInput('insurancePercent', e.target.value)}
                />
              </div>
            </div>
            <div className="col-6">
              <div className="form-group">
                <InputWrapper
                  id="ownCourierTariff"
                  label="Тариф на своих курьеров"
                  value={values.checkout?.ownCourierTariff}
                  onChange={(e) => handleChangeInput('ownCourierTariff', e.target.value)}
                />
              </div>
              <div className="form-group">
                <InputWrapper
                  id="selfPickupTariff"
                  label="Тариф за самовывоз"
                  value={values.checkout?.selfPickupTariff}
                  onChange={(e) => handleChangeInput('selfPickupTariff', e.target.value)}
                />
              </div>
              {/*              <div className="form-group">
                <InputWrapper
                  id="paymentAccountId"
                  label="ID аккаунта"
                  value={values.checkout?.paymentAccountId}
                  onChange={(e) => handleChangeInput('paymentAccountId', e.target.value)}
                />
              </div>*/}
            </div>
            <div className="col-6">
              <div className="form-group">
                <Toogle
                  id="enableExpenseDoc"
                  label={'enableExpenseDoc'}
                  checked={values.checkout?.enableExpenseDoc}
                  onChange={handleUpdateCheckbox}
                />
              </div>
            </div>
            <div className="col-6">
              <div className="form-group">
                <Toogle
                  id="onlySufficientOffers"
                  checked={values.checkout?.onlySufficientOffers}
                  onChange={handleUpdateCheckbox}
                  label={'onlySufficientOffers'}
                />
              </div>
            </div>
          </div>
        </section>
        <section>
          <h4 className="header-title" style={{ marginTop: '16px' }}>
            Другие опции
          </h4>
          <div className="row">
            <div className="col-6">
              <div className="form-group">
                <Select
                  label="Эквайринг провайдер"
                  options={PAYMENT_PROVIDERS}
                  value={PAYMENT_PROVIDERS.find(
                    (o) => o.value === values.checkout?.paymentProvider,
                  )}
                  onChange={({ value }) => handleChangeInput(`paymentProvider`, value)}
                />
              </div>
              <div className="form-group">
                <InputWrapper
                  id="personalInfoPolicyLink"
                  label="personalInfoPolicyLink"
                  value={values.checkout?.personalInfoPolicyLink}
                  onChange={(e) => handleChangeInput('personalInfoPolicyLink', e.target.value)}
                />
              </div>
            </div>
            <div className="col-6" style={{ marginTop: '26px' }}>
              <div className="form-group">
                <Checkbox
                  id="policyCheckEnabled"
                  onChange={handleUpdateCheckbox}
                  checked={values.checkout?.policyCheckEnabled}
                  label={'policyCheckEnabled'}
                />
              </div>
              <div className="form-group">
                <Checkbox
                  id="reserveAfterPayment"
                  onChange={handleUpdateCheckbox}
                  checked={values.checkout?.reserveAfterPayment}
                  label={'reserveAfterPayment'}
                />
              </div>
              <div className="form-group">
                <Checkbox
                  id="showConsentToNewsletter"
                  onChange={handleUpdateCheckbox}
                  checked={values.checkout?.showConsentToNewsletter}
                  label={'showConsentToNewsletter'}
                />
              </div>
              <div className="form-group">
                <Checkbox
                  id="showDeliveryOptions"
                  onChange={handleUpdateCheckbox}
                  checked={values.checkout?.showDeliveryOptions}
                  label={'showDeliveryOptions'}
                />
              </div>
              <div className="form-group">
                <Checkbox
                  id="showStocksPublic"
                  onChange={handleUpdateCheckbox}
                  checked={values.checkout?.showStocksPublic}
                  label={'showStocksPublic'}
                />
              </div>
              <div className="form-group">
                <Checkbox
                  id="unlockOrderDuringOnlinePayment"
                  onChange={handleUpdateCheckbox}
                  checked={values.checkout?.unlockOrderDuringOnlinePayment}
                  label={'unlockOrderDuringOnlinePayment'}
                />
              </div>
              <div className="form-group">
                <Checkbox
                  id="useNoCodPaymentName"
                  onChange={handleUpdateCheckbox}
                  checked={values.checkout?.useNoCodPaymentName}
                  label={'useNoCodPaymentName'}
                />
              </div>
            </div>
          </div>
        </section>
      </>
    );
  };

  return (
    <form onKeyDown={preventSubmittingByEnter} onSubmit={handleSubmit}>
      <div className="border-bottom">
        <h4 className="header-title">Публичные настройки</h4>
      </div>
      {checkout !== null && <div>{renderCheckoutSettings(checkout.objects[0])}</div>}
    </form>
  );
};

export default Checkout;
